import { Component, defineComponent } from '@decify/cell-shopify/client';
import './TabsContent.scss';
export const tabsContentName = 'TabsContent';
export const tabsContentTagName = 'cell-component-tabs-content';
export class TabsContent extends Component {
    classNames = {
        active: 'TabsContent--Active',
    };
    constructor() {
        super(tabsContentName);
        this.validateProps(['index']);
    }
    setActive() {
        this.classList.add(this.classNames.active);
    }
    setInactive() {
        this.classList.remove(this.classNames.active);
    }
}
defineComponent(tabsContentTagName, TabsContent);
